import { Component, Input, OnInit } from '@angular/core';
import { TyaIconData } from './tya-icon.data';

@Component({
  selector: 'tya-icon',
  templateUrl: './tya-icon.component.html',
  styleUrls: ['./tya-icon.component.scss']
})
export class TyaIconComponent implements OnInit {
  @Input() icon: string;
  @Input() spinner: boolean = false;
  @Input() size: string = '1.5 rem';
  @Input() color: string = 'black';
  @Input() opacity: number = 1;

  isEva = false;

  tyaIconData = TyaIconData;

  dataIcon: string;

  styleIcon = {
    'font-size': null,
    'color': null,
    'opacity': null,
  };

  constructor() { }

  ngOnInit(): void {
    const renderIcon = this.tyaIconData[this.icon];
    if (renderIcon.slice(0,3) != 'pi-') {
      this.isEva = true;
      this.dataIcon = renderIcon;
    }
    else {
      this.dataIcon = `pi ${renderIcon}`;
    }

    this.styleIcon['font-size'] = this.size;
    this.styleIcon['color'] = this.color;
    this.styleIcon['opacity'] = this.opacity;
  }
}
